import React from 'react';
import { IncidentAnalysis } from '../../types/incident';

interface HistoricalContextProps {
    analysis: IncidentAnalysis;
}

const HistoricalContext: React.FC<HistoricalContextProps> = ({ analysis }) => {
    return (
        <div className="space-y-6">
            {analysis.similar_incidents && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Historical Context</h4>
                    <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-700">Similar Incidents:</span>
                        <span className="text-sm font-bold text-blue-600">{analysis.similar_incidents}</span>
                    </div>
                    <div className="text-xs text-gray-600 mt-2">
                        Based on historical data analysis
                    </div>
                </div>
            )}

            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="pt-4 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        {analysis.is_from_history
                            ? 'This analysis is based on similar incidents resolved in the past. The system found matching patterns and provided historical solutions.'
                            : 'This analysis was generated by AI based on the incident description and current system knowledge.'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HistoricalContext;
